interface UseDeleteShopOverrideRuleParams {
	onSuccess?: () => void;
}

import { useApiMutation } from "./use-api-mutation";

export default function useDeleteShopOverrideRule(
	shopId: string,
	options?: UseDeleteShopOverrideRuleParams,
) {
	return useApiMutation("delete", "/shops/{shopId}/override-rules/{ruleId}", {
		onSuccess: options?.onSuccess,
		mapVariables: (ruleId: string) => ({
			params: { path: { shopId, ruleId } },
		}),
	});
}
